import useSWR from 'swr'
import { STORE_FAVOURITE } from 'app/constants/LOCALKEYS'
import { getPersistData } from '../persist'

const KEY = STORE_FAVOURITE

let swrData: any = getPersistData(KEY)
export function useFavourite(initData?: any) {
	const { data, mutate } = useSWR<any>(KEY, async () => {
		if (initData !== undefined) {
			swrData = initData
		}
		return swrData
	})

	return {
		data,
		mutate: (value: any) => {
			swrData = value
			return mutate()
		},
	}
}
